module.exports = __webpack_public_path__ + "img/calendar-outline.bab0e71d.svg";